import type { Category, MenuItem } from '../types';

export const categories: Category[] = [
  { id: 1, name: 'Appetizers' },
  { id: 2, name: 'Mains' },
  { id: 3, name: 'Desserts' },
  { id: 4, name: 'Drinks' },
  { id: 5, name: 'Sides' },
];

export const menuItems: MenuItem[] = [
  // Appetizers
  { id: 101, name: 'Spring Rolls', price: 8.50, categoryId: 1, imageUrl: 'https://picsum.photos/seed/food1/200' },
  { id: 102, name: 'Garlic Bread', price: 6.00, categoryId: 1, imageUrl: 'https://picsum.photos/seed/food2/200' },
  { id: 103, name: 'Bruschetta', price: 9.00, categoryId: 1, imageUrl: 'https://picsum.photos/seed/food3/200' },
  { id: 104, name: 'Calamari', price: 12.00, categoryId: 1, imageUrl: 'https://picsum.photos/seed/food4/200' },

  // Mains
  { id: 201, name: 'Spaghetti Bolognese', price: 22.00, categoryId: 2, imageUrl: 'https://picsum.photos/seed/food5/200' },
  { id: 202, name: 'Grilled Salmon', price: 28.50, categoryId: 2, imageUrl: 'https://picsum.photos/seed/food6/200', isSignatureDish: true },
  { id: 203, name: 'Chicken Parmesan', price: 25.00, categoryId: 2, imageUrl: 'https://picsum.photos/seed/food7/200' },
  { id: 204, name: 'Ribeye Steak', price: 35.00, categoryId: 2, imageUrl: 'https://picsum.photos/seed/food8/200' },
  { id: 205, name: 'Veggie Burger', price: 18.00, categoryId: 2, imageUrl: 'https://picsum.photos/seed/food9/200' },

  // Desserts
  { id: 301, name: 'Chocolate Lava Cake', price: 10.00, categoryId: 3, imageUrl: 'https://picsum.photos/seed/food10/200', isSignatureDish: true },
  { id: 302, name: 'Cheesecake', price: 9.50, categoryId: 3, imageUrl: 'https://picsum.photos/seed/food11/200' },
  { id: 303, name: 'Apple Crumble', price: 9.00, categoryId: 3, imageUrl: 'https://picsum.photos/seed/food12/200' },

  // Drinks
  { id: 401, name: 'Cola', price: 4.00, categoryId: 4, imageUrl: 'https://picsum.photos/seed/food13/200' },
  { id: 402, name: 'Orange Juice', price: 5.00, categoryId: 4, imageUrl: 'https://picsum.photos/seed/food14/200' },
  { id: 403, name: 'House Red Wine', price: 11.00, categoryId: 4, imageUrl: 'https://picsum.photos/seed/food15/200' },
  { id: 404, name: 'Latte', price: 5.50, categoryId: 4, imageUrl: 'https://picsum.photos/seed/food16/200' },
  
  // Sides
  { id: 501, name: 'French Fries', price: 7.00, categoryId: 5, imageUrl: 'https://picsum.photos/seed/food17/200' },
  { id: 502, name: 'Side Salad', price: 6.50, categoryId: 5, imageUrl: 'https://picsum.photos/seed/food18/200' },
];